export default __webpack_public_path__ + "static/media/select.533ee07a.svg";